<button mat-flat-button xpoSmallButton xpoButton (click)="navigateFn()">{{textBtn}}</button>
